<template>
<div ref="body">
    <base-header v-once pageName="고객상세" :popup="true"></base-header>

    <section id="wrap" :class="{move : move}" >
        <div class="swiper slideMenu cusReg" :class="{move : move}" v-swiper:myDirectiveSwiper="slideMenu" ref="slide">
            <div class="swiper-wrapper" ref="tabObj">
                <div class="swiper-slide"><em @click="focus('1')" :class="{ current: tabActive == 1 }">고객정보</em></div>
                <div class="swiper-slide"><em @click="focus('2')" :class="{ current: tabActive == 2 }">자녀정보</em></div>
                <div class="swiper-slide" v-if="custDiv =='SCD01'"><em @click="focus('3')" :class="{ current: tabActive == 3 }">계약정보</em></div>
                <div class="swiper-slide" v-if="custDiv =='SCD01'"><em @click="focus('4')" :class="{ current: tabActive == 4 }">주문정보</em></div>
                <div class="swiper-slide" v-if="custDiv =='SCD01'"><em @click="focus('5')" :class="{ current: tabActive == 5 }">배송정보</em></div>
                <div class="swiper-slide"><em @click="focus('7')" :class="{ current: tabActive == 7 }">일정정보</em></div>
                <div class="swiper-slide" v-if="this.$store.state.session.orgnzPstn == 'COG01'"><em @click="focus('8')" :class="{ current: tabActive == 8 }">리크루팅 정보</em></div>
                <div class="swiper-slide"><em @click="focus('9')" :class="{ current: tabActive == 9 }">이력정보</em></div>
            </div>
        </div>

        <div class="customer-detail">
            <div class="wrap" id="pos01" ref="pos01">
                <button type="button">고객 정보</button>
                <div class="cus-info">
                    <!-- 지국장인경우  EP 정보 노출 -->
                    <div class="cus-ep">
                        <p v-show="this.$store.state.session.orgnzPstn == 'COG01' && userInfo.orgnzPstn != 'COG01'" >
                            <span  @click="goOrgnzDetail(userInfo)">{{userInfo.userName}}</span> {{userInfo.orgnzPstnNm}}의 고객
                        </p>
                        <p v-if="custDiv == 'SCD01'">
                            교원키 : <span class="key">{{ custInfo.myCstmr.kwkkey }}</span>
                        </p>
                        <p v-if="custDiv == 'SCD02'">
                            소스 등록일 : <span class="key">{{ getFormattedDate(custInfo.myCstmr.custwstp, '-') }}</span>
                        </p>
                    </div>
                    <!--
                    <i v-if="custDiv == 'SCD01'">교원키 : {{ custInfo.myCstmr.kwkkey }}</i>
                    <i v-if="custDiv == 'SCD02'">소스 등록일 : {{ getFormattedDate(custInfo.myCstmr.custwstp, '-') }}</i>
                    <i v-if="this.$store.state.session.orgnzPstn == 'COG01'">//{{searchUserid}}//{{searchUserInfo.userName}}//{{searchUserInfo.orgnzPstnNm}}</i>
                    -->
                    <p>
                        <em :class="{contract: custInfo.myCstmr.custDivDetail == 'SCD01', prospect: custInfo.myCstmr.custDivDetail == 'SCD02', mom: custInfo.myCstmr.custDivDetail == 'SCD03', exp: custInfo.myCstmr.custDivDetail == 'SCD04' }">{{ custInfo.myCstmr.custDivDetailNm }}</em>
                        <span>{{ getNameGen() }}</span>
                        <button type="button" class="tel" title="전화" @click.stop="call(custInfo.myCstmr.kwctlNo)"></button>
                        <button type="button" class="email" title="문자" @click.stop="sms(custInfo.myCstmr)"></button>
                        <button type="button" class="favourite" :class="{ chk: custInfo.myCstmr.bookmarkYn == 'Y'? true : false }" title="즐겨찾기" @click.stop="updateBkmrYn(custInfo.myCstmr)"></button>
                    </p>
                    <div class="info wait" v-if="cusType">
                        <span class="tel">{{ getTelNum() }}</span>
                        <button type="button" @click="[ cusIpt = true ]" v-if="cusType" v-show="!cusIpt">추가정보 입력</button>
                        <button type="button" class="open" v-if="cusType" v-show="cusIpt" @click="addInfo">입력완료</button>
                        <dl v-if="cusType" v-show="cusIpt">
                            <template v-if="!custInfo.myCstmr.kwgend">
                                <dt>성별</dt>
                                <dd class="flex">
                                    <span class="radioBtn">
                                        <input type="radio" v-model="kwgendTemp" value="M" id="male" @keyup="checkVal">
                                        <label for="male">남</label>
                                    </span>
                                    <span class="radioBtn">
                                        <input type="radio"  v-model="kwgendTemp" value="F" id="female" @keyup="checkVal">
                                        <label for="female">여</label>
                                    </span>
                                </dd>
                            </template>
                            <template v-if="!custInfo.myCstmr.kwbrdt">
                                <dt>생년월일</dt>
                                <dd><input type="tel" ref="kwbrdtTemp" id="kwbrdtTemp" :value="kwbrdtTemp" v-on:input="checkText($event)" @keyup="checkVal" placeholder="8자리를 입력해주세요.(예 :19000101)"></dd>
                            </template>
                            <template v-if="!custInfo.myCstmr.kwsad1">
                                <dt>주소</dt>
                                <dd>
                                    <input type="text" ref="kwsad1Temp" id="kwsad1Temp" v-model="kwsad1Temp" placeholder="주소를 검색해주세요." @click="popPost" @keyup="popPost" readonly>
                                    <input type="text" ref="kwsad2Temp" id="kwsad2Temp" :value="kwsad2Temp" v-on:input="checkText($event)" placeholder="상세주소를 입력해주세요.">
                                </dd>
                            </template>
                        </dl>
                    </div>

                    <div class="info">
                        <span class="birth" v-if="custInfo.myCstmr.kwbrdt">  {{ getFormattedDate(custInfo.myCstmr.kwbrdt, '-') }}</span>
                        <span class="tel" v-if="!cusType">{{ getTelNum() }}</span>
                        <span class="address" v-if="custInfo.myCstmr.juso" >{{custInfo.myCstmr.juso}}</span>
                    </div>

                    <div class="btn">
                        <button type="button" v-if="session.orgnzPstn =='COG01'" @click="popBuyInfo">구매이력조회</button>
                        <button type="button" v-if="custDiv =='SCD02' || custInfo.myCstmr.custSyncYn" @click="popInterestInfo">관심및무진 정보</button>
                        <button type="button" @click="goEduPlan">에듀 플랜맵</button>
                        <button type="button" class="family" @click="popFamily">가구화 정보</button>
                        <button type="button" class="reg" @click="popCounsel"  v-if="isShowCounselBtn">
                            상담 리포트 작성
                        </button>
                    </div>

                    <div class="testWrap">
                        <h4 class="service-tit">진단 서비스</h4>
                        <div class="tabs">
                            <!-- 진단서비스 탭영역 -->
                            <button type="button" @click="selectSearchApi('KEDI')" :class="diagnosisInfo.examCd == 'KEDI' ? 'current' : ''">KED-I</button>
                            <button type="button" @click="selectSearchApi('KEDS')" :class="diagnosisInfo.examCd == 'KEDS' ? 'current' : ''">KED-S</button>
                            <button type="button" @click="selectSearchApi('KEDT')" :class="diagnosisInfo.examCd == 'KEDT' ? 'current' : ''">KED-T</button>
                            <button type="button" @click="selectSearchApi('KEDL')" :class="diagnosisInfo.examCd == 'KEDL' ? 'current' : ''">KED-L</button>
                            <button type="button" @click="selectSearchApi('ELT')" :class="diagnosisInfo.examCd == 'ELT' ? 'current' : ''">AI ELT</button>
                            <!-- //진단서비스 탭영역 -->
                        </div>

                        <template v-if="examSearch && (null == diagnosisList || diagnosisList.length == 0)">
                        <div class="service-view">
                            <!-- 진단서비스 항목 & 쿠폰발행 버튼  -->
                            <div class="coupon">
                                <button type="button"
                                    @click="moveCpnIssue()"
                                    v-html="'쿠폰발행'"></button>
                            </div>
                            <div>
                                <dl>
                                    <dt>대상자</dt>
                                    <dd>-</dd>
                                    <dt>진단일</dt>
                                    <dd>-</dd>
                                    <dt>재진단 예정일</dt>
                                    <dd>-</dd>
                                </dl>
                                <div class="btn">
                                    <button type="button" :disabled="true">결과보기</button>
                                    <button type="button" :disabled="true">공유하기</button>
                                </div>
                            </div>
                            <!-- <div class="dataNone" v v-if="diagnosisInfo.examCd=='KEDI'"> KED-I 진단검사 결과가 없습니다.</div>
                            <div class="dataNone" v v-if="diagnosisInfo.examCd=='KEDS'"> KED-S 진단검사 결과가 없습니다.</div>
                            <div class="dataNone" v v-if="diagnosisInfo.examCd=='ELT'"> AI ELT 진단검사 결과가 없습니다.</div> -->
                        </div>
                        </template>
                        <template v-if="diagnosisList.length > 0">
                        <div class="service-view">
                            <!-- 진단서비스 항목 & 쿠폰발행 버튼  -->
                            <div class="coupon">
                                <button type="button"
                                    @click="moveCpnIssue()"
                                    v-html="'쿠폰발행'"></button>
                            </div>
                            <!-- //진단서비스 항목 & 쿠폰발행 버튼  -->

                            <!-- swiper group -->
                            <swiper style="order:1" class="swiper swiperWrap" :options="swiperOption" ref="diagnosisSwiper">
                                <swiper-slide v-for="(diagnosis, index) in diagnosisList" :key="diagnosis.examNo">
                                    <div>
                                        <dl>
                                            <dt>대상자</dt>
                                            <dd>{{diagnosis.custNm}}</dd>
                                            <dt>진단일</dt>
                                            <dd>{{getFormattedDate(diagnosis.compDt,'-')}}</dd>
                                            <dt>재진단 예정일</dt>
                                            <dd>{{getFormattedDate(diagnosis.dueDate,'-')}}</dd>
                                        </dl>
                                        <div class="btn">
                                            <button type="button" @click="viewResult(index)" :disabled="isDgnstTstngShareable(index)">결과보기</button>
                                            <button type="button" @click="sendKakaoTalk(index)" :disabled="isDgnstTstngShareable(index)">공유하기</button>
                                        </div>
                                    </div>
                                </swiper-slide>
                                <div class="swiper-pagination swiperOption" slot="pagination"></div>
                            </swiper>
                            <!-- <div v-for="(diagnosis, index) in diagnosisList" :key="index">
                                <dl>
                                    <dt>대상자</dt>
                                    <dd>{{diagnosis.custNm}}</dd>
                                    <dt>진단일</dt>
                                    <dd>{{getFormattedDate(diagnosis.compDt,'-')}}</dd>
                                    <dt>재진단 예정일</dt>
                                    <dd>{{getFormattedDate(diagnosis.dueDate,'-')}}</dd>
                                </dl>
                                <div class="btn">
                                    <button type="button" @click="viewResult(index)">결과보기</button>
                                    <button type="button" @click="sendKakaoTalk(index)">공유하기</button>
                                </div>
                            </div> -->

                            <!-- <div>
                                <dl>
                                    <dt>대상자</dt>
                                    <dd>김교원</dd>
                                    <dt>진단일</dt>
                                    <dd>YYYY-MM-DD</dd>
                                    <dt>재진단 예정일</dt>
                                    <dd>YYYY-MM-DD</dd>
                                </dl>
                                <div class="btn">
                                    <button type="button">결과보기</button>
                                    <button type="button" disabled="disabled">공유하기</button>
                                </div>
                            </div> -->
                            <!-- swiper group -->
                        </div>
                        </template>
                    </div>

                    <!-- <div class="test">
                        <h6>진단서비스</h6>
                        <base-selectbox selectName="진단서비스"
                            :default="'진단서비스를 선택해주세요.'"
                            v-on:selectSearch="selectSearch"
                            :options="[{text:'KED-I',value:'KEDI'},{text:'KED-S',value:'KEDS'},{text:'AI ELT',value:'ELT'}]"
                        ></base-selectbox>

                        <template v-if="examSearch && (null == diagnosisList || diagnosisList.length == 0)">
                            <div class="dataNone" >진단검사 결과가 없습니다.</div>
                        </template>
                        <template v-if="diagnosisList.length > 0">
                        <div class="cont" v-for="(diagnosis, index) in diagnosisList" :key="index">
                            <dl>
                                <dt>대상자</dt>
                                <dd>{{diagnosis.custNm}}</dd>
                                <dt>진단일</dt>
                                <dd>{{getFormattedDate(diagnosis.compDt,'-')}}</dd>
                                <dt>재진단 예정일</dt>
                                <dd>{{getFormattedDate(diagnosis.dueDate,'-')}}</dd>
                            </dl>
                            <button type="button" @click="viewResult(index)">결과보기</button>
                            <button type="button" @click="sendKakaoTalk(index)">공유하기</button>
                        </div>
                        <button type="button" v-if="diagnosisList.length != orgDiagnosisList.length" @click="viewAllDiagnosis" class="more">더보기</button>
                        </template>
                    </div> -->

                </div>
            </div>
            <div class="wrap" id="pos02" ref="pos02">
                <button type="button">자녀 정보</button>
                <div>
                    <button type="button" class="add" v-if="custDiv =='SCD02'"  @click="addChildren">자녀등록</button>
                    <template v-if="null == custInfo.custFamilyList || custInfo.custFamilyList.length == 0">
                    <div class="dataNone" >등록된 자녀가 없습니다.</div>
                    </template>
                    <template v-if="custInfo.custFamilyList.length > 0">
                    <div class="child-name">
                        <strong>{{childName || '' }}</strong>
                        <div class="child-view">
                            <span v-if="childAge">{{childAge}}세</span>
                            <span v-if="childSex">{{childSex | checkKwgend}}</span>
                            <span v-if="childBirth">{{getFormattedDate(childBirth,'-')}} 일생</span>
                        </div>
                    </div>

                    <div :class="custDiv =='SCD02' ? 'child-info2' : 'child-info'">
                        <button type="button" class="mod" @click="modifyChildren();" v-if="custDiv =='SCD02'">수정</button>
                        <button type="button" class="del" @click="deleteChildren();" v-if="custDiv =='SCD02'">삭제</button>
                        <button type="button" class="info" @click="childSelect" v-if="this.custInfo.custFamilyList.length > 0"></button>
                    </div>
                    </template>

                    <template v-if="null == learnDataList || learnDataList.length == 0">
                        <h4 class="study-tit">학습 정보</h4>
                        <div class="dataNone" >진행중인 학습이 없습니다.</div>
                    </template>
                    <template v-if="null != learnDataList && learnDataList.length > 0">
                        <h4 class="study-tit">학습 정보 <span>(<em>{{ studyCurnt }}</em>/{{ studyTotal }})</span></h4>
                        <swiper class="swiper studyInfo" :options="studyOption" ref="study" >
                            <swiper-slide v-for="(learnData, index) in learnDataList" :key="index">
                                <template v-if="learnData.id == 'WP_IF_050004'"> <!-- 도요새 잉글리시 or 도요새 잉글리시 프리패스 -->
                                <div class="progress">
                                    <h5>{{learnData.prdNm}} <span>{{learnData.lrnngStep}}</span></h5>
                                    <h6>학습 진척도</h6>
                                    <span><em>{{learnData.lrnngPrgrs}}</em>% 진행중</span>
                                    <p><span :style="{'width': learnData.lrnngPrgrs +'%'}"></span></p>
                                    <dl>
                                        <dt>평균 학습시간</dt>
                                        <dd>{{getMinuteFromSeconds(learnData.avrgLrnngTm)}} 분</dd>
                                        <dt>다음 화상일정</dt>
                                        <dd>{{learnData.nextVidSchdl}}</dd>
                                        <dt>학습기간</dt>
                                        <dd>{{getFormattedDate(learnData.lrnngStrDt,'-')}} ~ {{getFormattedDate(learnData.lrnngEndDt,'-')}}</dd>
                                    </dl>
                                </div>
                                </template>
                                <template v-if="learnData.id == 'WP_IF_050005'"> <!-- 도요새중국어 -->
                                <div class="progress">
                                    <h5>{{learnData.prdNm}} <span>{{learnData.lrnngStep}}</span></h5>
                                    <h6>학습 진척도</h6>
                                    <span><em>{{learnData.lrnngPrgrs}}</em>% 진행중</span>
                                    <p><span :style="{'width': learnData.lrnngPrgrs +'%'}"></span></p>
                                    <dl>
                                        <dt>평균 학습시간</dt>
                                        <dd>{{getMinuteFromSeconds(learnData.avrgLrnngTm)}} 분</dd>
                                        <dt>다음 화상일정</dt>
                                        <dd>{{learnData.nextVidSchdl}}</dd>
                                        <dt>학습기간</dt>
                                        <dd>{{getFormattedDate(learnData.lrnngStrDt,'-')}} ~ {{getFormattedDate(learnData.lrnngEndDt,'-')}}</dd>
                                    </dl>
                                </div>
                                </template>
                                <template v-if="learnData.id == 'WP_IF_050011'"> <!-- 스마트빨간펜 -->
                                <div class="progress">
                                    <h5>{{learnData.prdNm}} <span>{{learnData.lrnngStep}} {{learnData.lrnngNextMth}}</span></h5>
                                    <h6>학습 진척도</h6>
                                    <span><em>{{learnData.lrnngPrgrs}}</em>% 진행중</span>
                                    <p><span :style="{'width': learnData.lrnngPrgrs +'%'}"></span></p>
                                    <dl>
                                        <dt>표준학습</dt>
                                        <dd>{{learnData.stndLrnng}} %</dd>
                                        <dt>다음 화상일정</dt>
                                        <dd>{{learnData.mckExamDt}}</dd>
                                        <dt>학습기간</dt>
                                        <dd>{{getFormattedDate(learnData.lrnngStrDt,'-')}} ~ {{getFormattedDate(learnData.lrnngEndDt,'-')}}</dd>
                                    </dl>
                                    <dl v-if="learnData.mockData">
                                        <dt>모의고사 ({{learnData.mockData.mckExamTp}})</dt>
                                        <dd>{{learnData.mockData.mckExamScr}}</dd>
                                        <dt>모의고사 응시일자</dt>
                                        <dd>{{getFormattedDate(learnData.mockData.mckExam,'-')}}</dd>
                                    </dl>
                                </div>
                                </template>
                                <template v-if="learnData.id == 'WP_IF_050006'"> <!-- 키즈빨간펜 -->
                                <div class="progress">
                                    <h5>{{learnData.prdNm}} <span>{{learnData.lrnngStep}}단계 {{learnData.lrnngNextMth}}차월</span></h5>
                                    <h6>학습 진척도</h6>
                                    <span><em>{{learnData.lrnngPrgrs}}</em>% 진행중</span>
                                    <p><span :style="{'width': learnData.lrnngPrgrs +'%'}"></span></p>
                                    <dl>
                                        <dt>평균 학습시간</dt>
                                        <dd>{{getMinuteFromSeconds(learnData.avrgLrnngTm)}} 분</dd>
                                        <dt>학습기간</dt>
                                        <dd>{{getFormattedDate(learnData.lrnngStrDt,'-')}} ~ {{getFormattedDate(learnData.lrnngEndDt,'-')}}</dd>
                                    </dl>
                                </div>
                                </template>
                                <template v-if="learnData.id == 'WP_IF_050007'"> <!-- 누리빨간펜 -->
                                <div class="progress">
                                    <h5>{{learnData.prdNm}} <span>{{learnData.lrnngStep}} 단계</span></h5>
                                    <h6>학습 진척도</h6>
                                    <span><em>{{learnData.lrnngPrgrs}}</em>% 진행중</span>
                                    <p><span :style="{'width': learnData.lrnngPrgrs +'%'}"></span></p>
                                    <dl>
                                        <dt>평균 학습시간</dt>
                                        <dd>{{getMinuteFromSeconds(learnData.avrgLrnngTm)}} 분</dd>
                                    </dl>
                                </div>
                                </template>
                                <template v-if="learnData.id == 'WP_IF_050012'"> <!-- AI수학 -->
                                <div class="progress">
                                    <h5>{{learnData.prdNm}} <span>{{learnData.lrnngStep}} {{learnData.lrnngNextMth}}</span></h5>
                                    <h6>학습 진척도</h6>
                                    <span><em>{{learnData.lrnngPrgrs}}</em>% 진행중</span>
                                    <p><span :style="{'width': learnData.lrnngPrgrs +'%'}"></span></p>
                                    <dl>
                                        <dt>평균 학습시간</dt>
                                        <dd>{{learnData.avrgLrnngTm}} 분</dd>
                                        <dt>다음 화상일정</dt>
                                        <dd>{{learnData.nextVidSchdl}}</dd>
                                        <dt>학습시작일</dt>
                                        <dd>{{learnData.lrnngStrDt}}</dd>
                                    </dl>
                                </div>
                                </template>
                                <template v-if="learnData.id == 'WP_IF_050008'"> <!-- 유아한글 -->
                                <div class="progress">
                                    <h5>{{learnData.prdNm}} <span>{{learnData.lrnngStep}} {{learnData.lrnngNextMth}}</span></h5>
                                    <dl>
                                        <dt>평균 학습시간</dt>
                                        <dd>{{getMinuteFromSeconds(learnData.avrgLrnngTm)}} 분</dd>
                                        <dt>학습기간</dt>
                                        <dd>{{getFormattedDate(learnData.lrnngStrDt,'-')}} ~ {{getFormattedDate(learnData.lrnngEndDt,'-')}}</dd>
                                    </dl>
                                </div>
                                </template>
                                <template v-if="learnData.id == 'WP_IF_050013'"> <!-- 유아 생각하는 수학 -->
                                <div class="progress">
                                    <h5>{{learnData.prdNm}} <span>{{learnData.lrnngStep}} {{learnData.lrnngNextMth}}</span></h5>
                                    <dl>
                                        <dt>평균 학습시간</dt>
                                        <dd>{{getMinuteFromSeconds(learnData.avrgLrnngTm)}} 분</dd>
                                        <dt>학습기간</dt>
                                        <dd>{{getFormattedDate(learnData.lrnngStrDt,'-')}} ~ {{getFormattedDate(learnData.lrnngEndDt,'-')}}</dd>
                                    </dl>
                                </div>
                                </template>
                                <template v-if="learnData.id == 'WP_IF_050009'"> <!-- 창의융합영재스쿨 -->
                                <div class="progress">
                                    <h5>{{learnData.prdNm}} <span>{{learnData.lrnngStep}} {{learnData.lrnngNextMth}}</span></h5>
                                    <h6>학습 진척도</h6>
                                    <span><em>{{learnData.lrnngPrgrs}}</em>% 진행중</span>
                                    <p><span :style="{'width': learnData.lrnngPrgrs +'%'}"></span></p>
                                    <dl>
                                        <dt>평균 독서시간</dt>
                                        <dd>{{getMinuteFromSeconds(learnData.avrgLrnngTm)}} 분</dd>
                                        <dt>다음 화상일정</dt>
                                        <dd>{{learnData.nextVidSchdl}}</dd>
                                        <dt>학습기간</dt>
                                        <dd>{{learnData.lrnngStrDt}} ~ {{learnData.lrnngEndDt}}</dd>
                                    </dl>
                                </div>
                                </template>
                                <template v-if="learnData.id == 'WP_IF_050010'"> <!-- 독서마라톤 -->
                                <div class="progress">
                                    <h5>{{learnData.prdNm}} <span>{{learnData.lrnngStep}}</span></h5>
                                    <h6>가산거리</h6>
                                    <span><em>{{learnData.extraTotSum}}</em>/ 총 100km</span>
                                    <p><span :style="{'width': removeKM(learnData.extraTotSum) +'%'}"></span></p>
                                    <dl>
                                        <dt>동일단계 가산거리 평균</dt>
                                        <dd>{{learnData.extraTotSum}} </dd> <!-- 항목이 없다!!! @@-->
                                        <dt>물약 사용여부</dt>
                                        <dd>{{learnData.ptnUseYn =='Y'? '사용' : '미사용'}}</dd>
                                        <dt>참여기간</dt>
                                        <dd>{{getFormattedDate(learnData.lrnngStrDt,'-')}} ~ {{getFormattedDate(learnData.lrnngEndDt,'-')}}</dd>
                                    </dl>
                                </div>
                                </template>
                            </swiper-slide>
                            <div class="swiper-pagination studyPage" slot="pagination"></div>
                            <button type="button" class="prev" slot="button-prev"></button>
                            <button type="button" class="next" slot="button-next"></button>
                        </swiper>
                    </template>

                    <!-- <h4 class="study-tit">북케어 정보</h4>
                    <div class="dataNone" v-if="null == bookCareList || bookCareList.length == 0">북케어 서비스를 받고 있지 않습니다.</div>
                    <template v-for="(bookCare, index, index1) in bookCareList">
                        <div class="bookCare" v-bind:key="index">
                            <dl>
                                <dt>단계</dt>
                                <dd>{{bookCare.rpgnam}}</dd>
                                <dt>사용기간</dt>
                                <dd>{{bookCare.rpkdcn}}</dd>
                                <dt>시작일</dt>
                                <dd>{{getFormattedMonth(bookCare.rpssym,'.')}}</dd>
                                <dt>종료일</dt>
                                <dd>{{getFormattedMonth(bookCare.rptym1,'.')}}</dd>
                            </dl>
                            <button type="button" v-bind:key="index1" @click="goCsmmView(bookCare)">방문확인</button>
                        </div>
                    </template> -->

                    <h4 class="study-tit">홈클래스 정보</h4>
                    <div class="dataNone" v-if="null == homeclassList || homeclassList.length == 0">홈클래스 서비스를 받고 있지 않습니다.</div>
                    <template v-for="(homeclass, index) in homeclassList">
                        <div class="homeclass" v-bind:key="index">
                            <dl>
                                <dt>상품명</dt>
                                <dd>{{homeclass.rpcna1}}</dd>
                                <dt>방문일</dt>
                                <dd>{{homeclass.nextVstDt}} / {{homeclass.vstDay }} {{ homeclass.vstTime }}</dd>
                                <dt>관리시작일</dt>
                                <dd>{{getFormattedMonth(homeclass.rpcdte,'.')}}</dd>
                                <dt>관리차월</dt>
                                <dd>{{homeclass.lednMnths + "개월"}}</dd>
                                <dt>교재진도</dt>
                                <dd>{{homeclass.rpfym}}</dd>
                            </dl>
                            <!-- <button type="button" v-bind:key="index1" @click="goCsmmView(homeclass)">방문확인</button> -->
                        </div>
                    </template>
                </div>
            </div>
            <div class="wrap" id="pos03" ref="pos03" v-if="custDiv =='SCD01'">
                <button type="button">계약 정보</button>
                <div>
                    <div class="dataNone" v-if="null == custInfo.contractInfoList || custInfo.contractInfoList.length == 0">계약 내역이 없습니다.</div>
                    <template v-if="null != custInfo.contractInfoList && custInfo.contractInfoList.length > 0">
                    <p class="contractCnt">(<em>{{cntrCurnt}}</em>/{{cntrTotal}})</p>
                    <swiper class="swiper contract" :options="contractOption">
                        <swiper-slide v-for="(contractInfo, index) in custInfo.contractInfoList" v-bind:key="index">
                            <dl>
                                <dt>계약번호</dt>
                                <dd>{{contractInfo.custYr}}-{{contractInfo.custSqno}}-{{contractInfo.custSeq}}</dd>
                                <dt>계약일자</dt>
                                <dd>{{ getFormattedDate(contractInfo.concdt,'-') }}</dd>
                                <dt>계약금액</dt>
                                <dd>{{contractInfo.kyAmt| comma}}원 {{contractInfo.concDiv == 'B' ? "(계약 시 납부금액)" : "" }}</dd>
                                <dt>계약방법</dt>
                                <dd>{{contractInfo.cashTypNm}}({{contractInfo.kyMont}}개월) {{contractInfo.concDiv == 'B' ? "(계약 시 결제수단)" : ""}}</dd>
                                <dt>월 납입액</dt>
                                <dd>{{contractInfo.kyCwmamt| comma}}원</dd>
                            </dl>
                        </swiper-slide>
                        <div class="swiper-pagination contractPage" slot="pagination"></div>
                    </swiper>
                    </template>
                    <div class="basic" v-if="custInfo.custMileageInfo != null">
                        <h6>마일리지 정보</h6>
                        <dl>
                            <dt>마일리지</dt>
                            <dd>{{custInfo.custMileageInfo.mileage| comma}}점</dd>
                        </dl>
                    </div>
                    <div class="basic" v-if="custInfo.custCreditInfo != null">
                        <h6>여신 정보</h6>
                        <dl>
                            <dt>잔여 할부 금액</dt>
                            <dd>{{custInfo.custCreditInfo.flpyblnc| comma}}원</dd>
                            <dt>연체금</dt>
                            <dd>{{custInfo.custCreditInfo.ovrdamt| comma}}원</dd>
                            <dt>전집 여신</dt>
                            <dd>{{custInfo.custCreditInfo.cwiamt| comma}}원</dd>
                        </dl>
                    </div>
                </div>
            </div>
            <div class="wrap" id="pos04" ref="pos04" v-if="custDiv =='SCD01'">
                <button type="button">주문 정보</button>
                <div>
                    <div class="dataNone" v-if="null == custOrderInfoList || custOrderInfoList.length == 0">주문정보가 없습니다.</div>
                    <template v-for="(custOrderInfo, index, index1) in custOrderInfoList" >
                        <dl class="order" v-bind:key="index">
                            <dt>{{custOrderInfo.catCdNm}}</dt>
                            <template v-for="(order, index2) in custOrderInfo.orderInfo">
                            <dd v-bind:key="index2" v-if="index2 < 3 || custOrderInfo.viewYn == 'Y'" :class="[order.concstatNm=='기간만료'?'finish':'']">
                                <em>{{order.prdtnm}}</em>
                                <span>{{order.kyAmt| comma}}원</span>
                                <i>[{{order.custYr}}-{{order.custSqno}}-{{order.custSeq}}] / {{ getFormattedDate(order.concdt,'-') }}</i>
                                <i>{{order.concstatNm}}</i>
                            </dd>
                            </template>
                        </dl>
                        <button type="button" v-bind:key="index1" v-if="custOrderInfo.orderInfo.length > 3" @click="toggleCustOrderAllView(custOrderInfo)" class="more" :class="{ close: custOrderInfo.viewYn == 'Y'}">{{custOrderInfo.viewYn == 'N'?'펼치기':'닫기'}}</button>
                    </template>
                </div>
            </div>
            <div class="wrap" id="pos05" ref="pos05" v-if="custDiv =='SCD01'">
                <button type="button">배송 정보</button>
                <div>
                    <div class="dataNone" v-if="null == custInfo.custRlsInfo">배송정보가 없습니다.</div>
                    <div class="basic" v-if="null != custInfo.custRlsInfo">
                        <dl>
                            <dt>주문상품</dt>
                            <dd>{{custInfo.custRlsInfo.prdtnm}}</dd>
                            <dt>주문정보</dt>
                            <dd>{{custInfo.custRlsInfo.custYr}}-{{custInfo.custRlsInfo.custSqno}}</dd>
                            <!-- <dt>배송지명</dt>
                            <dd>{{custInfo.custRlsInfo.cwwnam}}</dd> -->
                            <dt>배송지 주소</dt>
                            <dd>{{custInfo.custRlsInfo.cwwad1}}{{custInfo.custRlsInfo.cwwad2}}</dd>
                            <dt v-if="custInfo.custRlsInfo.concDiv == 'C'">배송구분</dt>
                            <dd v-if="custInfo.custRlsInfo.concDiv == 'C'">{{custInfo.custRlsInfo.cwtgubNm}}</dd>
                            <dt>배송일자</dt>
                            <dd>{{ getFormattedDate(custInfo.custRlsInfo.rlsdt,'-') }}</dd>
                            <dt>배송상태</dt>
                            <dd>{{custInfo.custRlsInfo.rlsdtNm}}</dd>
                        </dl>
                        <span>※ 실제 배송 일정과 상이할 수 있으며, 택배의 경우 출고일 기준 1~2영업일 수령 가능합니다.</span>
                    </div>
                </div>
            </div>
            <div class="wrap" id="pos06" ref="pos06" v-if="custDiv =='SCD01'"></div>
            <div class="wrap" id="pos07" ref="pos07">
                <button type="button">일정 정보</button>
                <div class="myschedule">
                    <button v-if="custDiv != 'SCD01'" type="button" class="calendar" @click="goKssCstmDtl">방문상담 알림</button>
                    <button type="button" class="add" @click="goMyScheduleReg">일정등록</button>
                    <div class="dataNone" v-if="custInfo.myScheduleList.length + custInfo.myHomeclassList.length == 0">등록된 일정이 없습니다.</div>
                    <ul>
                        <li  v-for="(homeclass,index) in custInfo.myHomeclassList" v-bind:key="index" v >
                            <em class="my">방문</em>
                            <div class="homeclass-items">
                            <span>({{ homeclass.vstDywkNm}}) {{ homeclass.vstHr }} {{homeclass.sbjcNm}}</span>
                            </div>
                        </li>
                    </ul>
                    <!-- 테스트용 <button type="button" class="schedule" v-for="(myHomeclass, index) in custInfo.myHomeclassList" :key="index" @click="popView(index)">
                        <span>({{myHomeclass.vstDywkNm}})  {{myHomeclass.vstHr}}</span>
                        <p>{{myHomeclass.sbjcNm}}</p>
                    </button>  -->
                    <button type="button" class="schedule" v-for="(mySchedule, index) in custInfo.myScheduleList" :key="index" @click="popView(index)">
                        <span>{{mySchedule.sttDt}}  {{mySchedule.sttHr}} {{mySchedule.scdlDivNm}}</span>
                        <p>{{mySchedule.addr}} {{mySchedule.addrNm}}</p>
                    </button>
                </div>
            </div>
            <div class="wrap" id="pos08" ref="pos08" v-if="this.$store.state.session.orgnzPstn == 'COG01'">
                <button type="button">리크루팅 정보</button>
                <div>
                    <dl class="recurit">
                        <dt>리크루팅 관심여부</dt>
                        <dd>
                            <span class="radio">
                                <input type="radio" v-model="custInfo.myCstmr.rcrtYn" id="recu-Y" value="Y">
                                <label for="recu-Y">관심있음</label>
                            </span>
                            <span class="radio">
                                <input type="radio" v-model="custInfo.myCstmr.rcrtYn" id="recu-N" value="N">
                                <label for="recu-N">관심없음</label>
                            </span>
                        </dd>
                        <dd class="btn">
                            <button type="button" @click="popRecruitInfo">기존 리크루팅 조회</button>
                            <button type="button" @click="updateRecruitYn(custInfo.myCstmr)">관심여부 저장</button>
                        </dd>
                    </dl>
                    <dl class="recurit">
                        <dt>파트너 등록</dt>
                        <dd class="btn">
                            <button type="button" @click="popSendUrlPage">URL 발송</button>
                            <button type="button" @click="popSendPartnerPage">외국인 파트너 등록</button>
                        </dd>
                    </dl>
                </div>
            </div>
            <div class="wrap" id="pos09" ref="pos09">
                <button type="button">이력 정보</button>
                <div>
                    <button type="button" class="add" @click="openMemoPop">메모하기</button>
                    <div class="dataNone" v-if="custMemoList.length < 1">이력정보 내역이 없습니다.</div>
                    <ul class="memo">
                        <li v-for="(memo, index) in custMemoList" :key="index">
                            <span>{{memo.crtnDttm}}</span>
                            <p :class="{close : memo.isMemoView}">{{memo.memo}}</p>
                            <button type="button" class="mod" @click="openModifyMemoPop(index)" v-if="memo.amntPsblYn === 'Y'">수정</button>
                            <button type="button" class="del" @click="deleteCustMemo(index)" v-if="memo.amntPsblYn === 'Y'">X</button>
                            <button type="button" class="open" v-if="memo.memo.length > 52 || memo.memo.split('').filter(x => x == '\n').length >= 2" :class="{close : memo.isMemoView}" @click="memoView(memo)">더보기</button>
                        </li>
                    </ul>

                    <button type="button" v-if="!memoListFinal" @click="getCustMemoList" class="more">펼치기</button>
                </div>
            </div>
        </div>
    </section>

    <template v-if="child">
        <div class="dim">
            <div class="botWrap list-save">
                <h6>자녀 목록</h6>
                <ul class="child">
                    <li v-for="(childList, index) in custInfo.custFamilyList" :key="index" @click="childChange(index)">
                        <strong v-if="childList.chlnNm">{{ childList.chlnNm }}</strong>
                        <span v-if="childList.age"> {{ childList.age }}세 </span>
                        <span v-if="childList.kwgend"> , {{ childList.kwgend | checkKwgend}} </span>
                        <span v-if="childList.chlnBrdt"> , {{ getFormattedDate(childList.chlnBrdt,'-') }} 일생 </span>
                    </li>
                </ul>
                <button type="button" class="close" @click="hideListView">닫기</button>
            </div>
        </div>
    </template>
</div>
</template>

<script>
import _ from 'lodash';
export default {
  computed: {
    // 상담 리포트 작성 버튼 노출 여부 계산
    isShowCounselBtn() {
      // 1. 고객 구분 체크 ('SCD01' 계약고객, 'SCD02' 가망고객 둘 다 허용)
      const isValidDiv = ['SCD01', 'SCD02'].includes(this.custDiv);

      // 2. 전화번호 3개가 모두 존재하는지 체크 (null, undefined, 빈 문자열 방어)
      const cstmr = this.custInfo && this.custInfo.myCstmr;
      const hasAllPhones = Boolean(cstmr && cstmr.tel1 && cstmr.tel2 && cstmr.tel3);

      // 3. 두 조건이 모두 참일 때만 true 반환
      return isValidDiv && hasAllPhones;
    }
  },
  data(){
      var self = this;
      return{
        swiperOption: {
        //   loop : true,
          initialSlide: 0,
          pagination: {
            el: '.swiperOption'
          },
        },
        kwgendTemp: "", // 가망고객 추가정보 성별
        kwbrdtTemp: "", // 가망고객 추가정보 생일
        kwszipTemp: "", // 가망고객 추가정보 주소 Zip코드
        kwsad1Temp: "", // 가망고객 추가정보 주소1
        kwsad2Temp: "", // 가망고객 추가정보 주소2

        session: this.$store.state.session,

        searchUserid: "",
        kwkkey: "",
        custDiv: "",
        custDivDetail: "",
        custDivDetailNm: "",
        memoDiv: "0", // 메모구분, 0: EP, 1: 고객 메모 등록시..
        memoListFinal: false, // 메모리스트 조회 끝
        memoTot: 0, // 메모 전체 갯수
        memoOffset: 0, // 메모 처음 조회시작부분
        memoSize: 10, // 메모 조회 사이즈
        myScheduleListIndex: -1, // 일정상세 팝업 호출시 삭제를 대비하여 index 저장.
        custInfo: {
            myCstmrEnc: {},
            myCstmr: {},
            myScheduleList: [],
            myHomeclassList: [], // 홈클래스 일정 관리
            custFamilyList: [
                {
                    chlnNm: "",
                    kwgend: "",
                    age: "",
                    chlnBrdt: "",
                }
            ],
            contractInfoList: [
                {
                    custYr: "",
                    custSqno: "",
                    custSeq: "",
                    concdt: "",
                    kyAmt: 0,
                    cashTypNm: "",
                    kyMont: "",
                    kyCwmamt: 0
                }
            ],
            custMileageInfo: {mileage:0},
            custCreditInfo: {
                cwiamt: 0,
                flpyblnc: 0,
                ovrdamt: 0,
            },
            orgCustOrderInfoList: [],
            custRlsInfo: {
                custYr: "",
                custSqno: "",
                cwwnam: "",
                cwwad1: "",
                cwwad2: "",
                rlsdt: "",
                rlsdtNm: "",
                prdtnm: "",
            },
            custInterestInfoList: [], // 관심정보 및 무진활동
            tempCustInterestInfoList: [], // 관심정보 및 무진활동 서버 전달용.
        },
        custMemoList: [],
        custOrderInfoList: [],
        diagnosisInfo:{
              examCd: 'KEDI'
            , dgnstTstngCpnCnt: 0
        },
        diagnosisList: [],
        orgDiagnosisList: [],
        learnDataList: [],
        bookCareList: [],
        homeclassList: [], // 홈클래스 방문확인용 리스트

        slideMenu: {
          slidesPerView: 'auto'
        },

        cusType: false,
        cusIpt: false,

        // 진행중인 학습
        studyCurnt: 0,
        studyTotal: 0,
        studyOption: {
          //loop: true,
          spaceBetween : 30,
          pagination: {
            el: '.studyPage'
          },
          navigation: {
            nextEl: '.next',
            prevEl: '.prev'
          },
          on: {
            slideChange() {
              self.studyCurnt = this.realIndex+1
              self.studyTotal = this.slides.length
            }
          }
        },

        // 계약정보
        cntrCurnt: 0,
        cntrTotal: 0,
        contractOption: {
          //loop: true,
          spaceBetween : 30,
          pagination: {
            el: '.contractPage'
          },
          on: {
            slideChange() {
              self.cntrCurnt = this.realIndex+1
              self.cntrTotal = this.slides.length
            }
          }
        },

        // 자녀 목록
        child: false,
        childName: null,
        childSex: null,
        childAge: null,
        childBirth: null,
        childSqno: null,

        isMemoView: undefined,

        move : false,
        tabActive: 1,
        examSearch: false,

        dgnstTstngCpn: {
              aieltRmnngCnt: '0'
            , tedsRmnngCnt: '0'
            , tediRmnngCnt: '0'
        },
        searchUserInfo:{
            userId: 0,
            userName: '',
            orgnzPstn: '',
            orgnzPstnNm: '',
        },
        userInfo: {
          userid: "",
          userName: "",
          orgnzPstn: "",
          orgnzPstnNm: ""
        }
      };
  },
  watch: { // 팝업창에서 값 받는 부분.
    '$store.state.ui.child'(child) {
        if(child.name == 'sms-send-complete'){  // 문자발송이 완료되었을 때
        }
        if(child.name == 'memo-save-complete'){  // 메모저장이 완료되었을 때
            this.memoListFinal = false;
            this.setCustMemoinit(); //초기화.
            this.getCustMemoList();
        }
        if(child.name == 'juso-selected'){  // 주소검색 팝업에서 받은 값.
            this.kwszipTemp = this.$store.state.ui.child.data.zipNo;
            this.kwsad1Temp = this.$store.state.ui.child.data.roadAddr;
            this.$refs.kwsad1Temp.value = this.$store.state.ui.child.data.roadAddr;
            this.$refs.kwsad2Temp.focus();
        }
        if(child.name == 'add-children-result'){  // 자녀등록 팝업에서 값이 넘어올 때
            console.log("MyCstmrView.vue watch add-children-result this.$store.state.ui.child.data:", this.$store.state.ui.child.data);

            // 3세(36개월) 형태에서 나이만 추출
            let age = parseInt(this.$store.state.ui.child.data.age, 10);
            age = isNaN(age) ? '' : age + '';

            var newChildInfo = {
                chlnNm: this.$store.state.ui.child.data.chlnnam,
                kwgend: this.$store.state.ui.child.data.chlngndr,
                chlnBrdt: this.$store.state.ui.child.data.chlnbdt,
                age: age + '',
                custDiv: this.custDiv,
                kwkkey: this.kwkkey,
                addChild: "Y",
                memoDiv: "0",
                Memo: "자녀가 추가되었습니다.",
                sqno: this.custInfo.custFamilyList.length
            };

            this.custInfo.custFamilyList.push(newChildInfo);

            // 첫 번째 자녀 추시 자녀 셀렉트 박스 영역 출력 용 데이터 셋팅
            if (this.custInfo.custFamilyList.length === 1) {
                let v = this.custInfo.custFamilyList[0];
                this.childName = v.chlnNm;
                this.childSex = v.kwgend;
                this.childAge = v.age;
                this.childBirth = v.chlnBrdt;
                this.childSqno = 0;
            }

            this.updateCustInfo(newChildInfo);
        }
        if(child.name == 'modify-children-result'){  // 자녀수정 팝업에서 값이 넘어올 때
            console.log("MyCstmrView.vue watch modify-children-result this.$store.state.ui.child.data:",this.$store.state.ui.child.data);

            // 3세(36개월) 형태에서 나이만 추출
            let age = parseInt(this.$store.state.ui.child.data.age, 10);
            age = isNaN(age) ? '' : age + '';

            // 수정한 자녀 정보 갱신
            _.each(this.custInfo.custFamilyList, v => {
                if (v.sqno === this.$store.getters.ui.child.data.sqno) {
                    v.chlnNm = this.$store.state.ui.child.data.chlnnam;
                    v.kwgend = this.$store.state.ui.child.data.chlngndr;
                    v.chlnBrdt = this.$store.state.ui.child.data.chlnbdt;
                    v.age = age

                    this.childName = v.chlnNm;
                    this.childSex = v.kwgend;
                    this.childAge = v.age;
                    this.childBirth = v.chlnBrdt;
                }
            });

            const changeInfo = {
                custDiv: this.custDiv,
                kwkkey: this.kwkkey,
                addChild: "Y",
                memoDiv: "0",
                Memo: "자녀가 수정되었습니다."
            };

            this.updateCustInfo(changeInfo);
        }
        if(child.name == 'interestinfo-update-result'){  // 관심 및 무진정보 팝업에서 값이 넘어올 때
            console.log("MyCstmrView.vue watch interestinfo-update-result this.$store.state.ui.child.data:",this.$store.state.ui.child.data);

            this.custInfo.myCstmr = this.$store.state.ui.child.data.myCstmr;
            this.custInfo.custInterestInfoList = this.$store.state.ui.child.data.custInterestInfoList;

            var changeInfo = {
                                custDiv: this.custDiv,
                                kwkkey: this.kwkkey,
                                changeInterest: "Y",
                                memoDiv: "0",
                                Memo: "고객 관심정보가 등록(변경)되었습니다."
                            };
            this.updateCustInfo(changeInfo);
        }
        if(child.name == 'family-pop-selected-chlnkwkey'){ // 가구화 정보 팝업에서 값이 넘어올 때
            console.log("MyCstmrView.vue watch family-pop-selected-chlnkwkey this.$store.state.ui.child.data:",this.$store.state.ui.child.data);
            this.kwkkey = this.$store.state.ui.child.data.selectedChlnKwkey;

            // 고객정보 조회
            this.getMyCstmr();
        }
        if(child.name == 'reload-myschedule'){  // 상세화면에서 일정 삭제한 후 해당일정 삭제.
            this.custInfo.myScheduleList.splice(this.myScheduleListIndex,1); // 화면 목록에서 삭제처리.
		}
    }
  },
  created () {
    window.addEventListener('scroll', this.focusScroll);
  },
  destroyed () {
    window.removeEventListener('scroll', this.focusScroll);
  },
  methods: {
    focusScroll () {
        this.isUserScrolling = (window.scrollY > 0);
        this.pos01Top = this.$refs.pos01.offsetTop;
        this.pos01 = this.$refs.pos01.offsetTop + this.$refs.pos01.clientHeight;
        this.pos02Top = this.$refs.pos02.offsetTop;
        this.pos02 = this.$refs.pos02.offsetTop + this.$refs.pos02.clientHeight;
        this.pos07Top = this.$refs.pos07.offsetTop;
        this.pos07 = this.$refs.pos07.offsetTop + this.$refs.pos07.clientHeight;
        this.pos09Top = this.$refs.pos09.offsetTop;
        this.pos09 = this.$refs.pos09.offsetTop + this.$refs.pos09.clientHeight;
        if(this.custDiv == 'SCD01'){
            this.pos03Top = this.$refs.pos03.offsetTop;
            this.pos03 = this.$refs.pos03.offsetTop + this.$refs.pos03.clientHeight;
            this.pos04Top = this.$refs.pos04.offsetTop;
            this.pos04 = this.$refs.pos04.offsetTop + this.$refs.pos04.clientHeight;
            this.pos05Top = this.$refs.pos05.offsetTop;
            this.pos05 = this.$refs.pos05.offsetTop + this.$refs.pos05.clientHeight;
            // this.pos06Top = this.$refs.pos06.offsetTop;
            // this.pos06 = this.$refs.pos06.offsetTop + this.$refs.pos06.clientHeight;
        }
        if(this.$store.state.session.orgnzPstn == 'COG01') {
            this.pos08Top = this.$refs.pos08.offsetTop;
            this.pos08 = this.$refs.pos08.offsetTop + this.$refs.pos08.clientHeight;
        }

        if(this.isUserScrolling){
            this.move = true
            var scrollSum = window.scrollY + 120;
            if(scrollSum >= this.pos01Top && scrollSum <= this.pos01){
                    this.tabActive = 1;
            }else if(scrollSum >= this.pos02Top && scrollSum <= this.pos02){
                    this.tabActive = 2;
            }else if(this.custDiv == 'SCD01' && scrollSum >= this.pos03Top && scrollSum <= this.pos03){
                    this.tabActive = 3;
            }else if(this.custDiv == 'SCD01' && scrollSum >= this.pos04Top && scrollSum <= this.pos04){
                    this.tabActive = 4;
            }else if(this.custDiv == 'SCD01' && scrollSum >= this.pos05Top && scrollSum <= this.pos05){
                    this.tabActive = 5;
            }
            // else if(this.custDiv == 'SCD01' && scrollSum >= this.pos06Top && scrollSum <= this.pos06){
            //         this.tabActive = 6;
            // }
            else if(scrollSum >= this.pos07Top && scrollSum <= this.pos07){
                    this.tabActive = 7;
            }else if(this.$store.state.session.orgnzPstn == 'COG01' && scrollSum >= this.pos08Top && scrollSum <= this.pos08){
                    this.tabActive = 8;
            }else if(scrollSum >= this.pos09Top && scrollSum <= this.pos09){
                    this.tabActive = 9;
            }
        }else{
            this.move = false
        }
        if(this.custDiv == 'SCD01'){
            if( window.scrollY > this.$refs.body.scrollHeight/2){
                this.$refs.tabObj.style.transform = 'translate3d(-350px, 0px, 0px)'
                this.$refs.tabObj.style.transform = 'transition-duration: 300ms'
            }
        }
    },
    focus(val){
        var d = document.getElementById('pos0'+val);
        var topPos = d.offsetTop - 110;
        window.scrollTo({top:topPos});
        this.tabActive = val
    },
    params() { // 등록/수정 데이터 리턴. 날짜는 '-' 제거.
        return {
            akdcde: this.custInfo.myCstmr.akdcde,
            custsrno: this.custInfo.myCstmr.kwkkey,
            custname: this.custInfo.myCstmr.custnm,
            custhno1: this.custInfo.myCstmr.tel1,
            custhno2: this.custInfo.myCstmr.tel2,
            custhno3: this.custInfo.myCstmr.tel3,
            custgndr: this.custInfo.myCstmr.kwgend,
            custbrdt: this.custInfo.myCstmr.kwbrdt,
            custzpcd: this.custInfo.myCstmr.kwszip,
            custadr1: this.custInfo.myCstmr.kwsad1,
            custadr2: this.custInfo.myCstmr.kwsad2,
            chlnnam1: this.custInfo.myCstmr.chlnnam1,
            chlnbdt1: this.custInfo.myCstmr.chlnbdt1,
            chlngndr1: this.custInfo.myCstmr.chlngndr1,
            chlnnam2: this.custInfo.myCstmr.chlnnam2,
            chlnbdt2: this.custInfo.myCstmr.chlnbdt2,
            chlngndr2: this.custInfo.myCstmr.chlngndr2,
            chlnnam3: this.custInfo.myCstmr.chlnnam3,
            chlnbdt3: this.custInfo.myCstmr.chlnbdt3,
            chlngndr3: this.custInfo.myCstmr.chlngndr3,
            chlnnam4: this.custInfo.myCstmr.chlnnam4,
            chlnbdt4: this.custInfo.myCstmr.chlnbdt4,
            chlngndr4: this.custInfo.myCstmr.chlngndr4,
            chlnnam5: this.custInfo.myCstmr.chlnnam5,
            chlnbdt5: this.custInfo.myCstmr.chlnbdt5,
            chlngndr5: this.custInfo.myCstmr.chlngndr5,
            prensrno: this.custInfo.myCstmr.prensrno,
            custnote: this.custInfo.myCstmr.custnote,
            infoagre: this.custInfo.myCstmr.infoagre,
            mrknagre: this.custInfo.myCstmr.mrknagre,
            interestListJsonString: JSON.stringify(this.custInfo.tempCustInterestInfoList)

        };
    },
    checkVal: function(e){ // 포커스 이동
        if(e.target.id == 'male' || e.target.id == 'female' ){
                this.$refs.kwbrdtTemp.focus();
        }else if(e.target.id == 'kwbrdtTemp' ){
            if(e.target.value.length == 8){
                if(this.$refs.kwsad1Temp == undefined) {
                    return;
                }
                this.$refs.kwsad1Temp.focus();
            }
        }
    },
    popPost(){ // 주소검색 창 띄우기
        this.$utils.nativeIf.outbound.newPage('/commonPopup/postSearch/');
    },
    getMyCstmr: function(){ // 고객정보 조회
        var that = this;

        var parameters = {
            searchUserid: this.searchUserid,
            kwkkey: this.kwkkey,
            custDiv: this.custDiv,   //SCD01: 계약, SCD02: 가망
            onlyChild: "Y" // 고객 가구화정보에서 자녀정보만 조회
        };
        console.log("MyCstmrView.vue mounted parameters:",parameters);

        this.$api.myCstmr.getMyCstmr(parameters)
            .then(function(res) {
                console.log("MyCstmrView.vue <api.myCstmrList.getMyCstmr res:",res);
                that.custInfo = res;

                // 이력정보 - 메모 목록조회.
                that.getCustMemoList();

                // 계약정보가 있을 때
                if( that.custInfo.contractInfoList && that.custInfo.contractInfoList.length > 0){
                    that.cntrCurnt = 1;
                    that.cntrTotal = that.custInfo.contractInfoList.length;
                }

                // 주문정보가 있을 때
                if(null != that.custInfo.orgCustOrderInfoList){
                    that.custOrderInfoList = that.groupBy(that.custInfo.orgCustOrderInfoList);
                    // console.log("MyCstmrView.vue <api.myCstmrList.getMyCstmr custOrderInfoList:",that.custOrderInfoList);
                }

                // 주소 셋팅
                if(that.custInfo.myCstmr.kwsad1){ // 신주소가 있으면 신주소를 보여주고, 없으면 구주소를 보여준다.
                    that.custInfo.myCstmr.juso = "(" + that.custInfo.myCstmr.kwszip + ") " + that.custInfo.myCstmr.kwsad1;
                    if(that.custInfo.myCstmr.kwsad2){
                        that.custInfo.myCstmr.juso = that.custInfo.myCstmr.juso + " " + that.custInfo.myCstmr.kwsad2;
                    }
                }else if(that.custInfo.myCstmr.kwhad1){
                    that.custInfo.myCstmr.juso = "(" + that.custInfo.myCstmr.kwhzip + ") " + that.custInfo.myCstmr.kwhad1;
                    if(that.custInfo.myCstmr.kwhad2){
                        that.custInfo.myCstmr.juso = that.custInfo.myCstmr.juso + " " + that.custInfo.myCstmr.kwhad2;
                    }
                }

                // 가망고객일 때, 추가정보버튼 설정
                if("SCD02" == that.custDiv){
                    if(!that.custInfo.myCstmr.kwgend || !that.custInfo.myCstmr.kwbrdt || !that.custInfo.myCstmr.kwsad1){ // 성별, 생년월일, 주소가 등록되어있지 않으면 추가정보 입력 상태로 설정.
                        that.cusType = true;
                    }
                }

                // 자녀정보 설정
                if(that.custInfo.custFamilyList.length > 0){ // 자녀정보가 있으면, 첫번째 자녀를 보여준다.
                    that.learnDataList = [];
                    that.childChange(0);
                }

                // 배명훈, 2021-11-29, 진단서비스 조회
                that.selectSearchApi('KEDI');
            })
            .catch(function(error) {
                alert(error.rtMsg);
            });

        // TODO : 배명훈, 20211125, 진단쿠폰 잔여정보 조회
        // this.$api.dgnstTstng.getDgnstTstngCpnInfo({})
        //     .then(function(data) {
        //         console.log("MyCstmrView.vue <api.dgnstTstng.getDgnstTstngCpnInfo.data:", data);
        //         that.dgnstTstngCpn.aieltRmnngCnt = data.aieltRmnngCnt;
        //         that.dgnstTstngCpn.tedsRmnngCnt = data.tedsRmnngCnt;
        //         that.dgnstTstngCpn.tediRmnngCnt = data.tediRmnngCnt;
        //     })
        //     .catch(function(error) {
        //         alert(error.rtMsg);
        //     });

    },
    moveCpnIssue: function() {
        // 배명훈, 2021-11-29
        var examCd = this.diagnosisInfo.examCd;
        var t1 = btoa(this.custInfo.myCstmr.tel1);
        var t2 = btoa(this.custInfo.myCstmr.tel2);
        var t3 = btoa(this.custInfo.myCstmr.tel3);

        var url = "";
        // alert(examCd);
        if(examCd == 'KEDI' || examCd == 'KEDS') {
            var cType = (examCd == 'KEDI')?"Y":"K";
            if(this.$store.getters.orgnzPstn == 'COG01'
                || this.$store.getters.orgnzPstn == 'COG02'){
                url = "/cpon/cponKedDivide?cType="+cType+"&t1="+t1+"&t2="+t2+"&t3="+t3;
                // 지구장, 지국장
                this.$utils.external.kss(url);
            } else {
                url = "/cpon/cponKedSend?cType="+cType+"&t1="+t1+"&t2="+t2+"&t3="+t3;
                this.$utils.external.kss(url);
            }
        } else if(examCd == 'ELT') {
            if(this.$store.getters.orgnzPstn == 'COG01'){
                // 지구장
                url = "/cpon/cponDivide?cType=ELT&t1="+t1+"&t2="+t2+"&t3="+t3;
                this.$utils.external.kss(url);
            }else{
                url = "/cpon/cponSend?cType=ELT&t1="+t1+"&t2="+t2+"&t3="+t3;
                this.$utils.external.kss(url);
            }
        }
    },
    // getDgnstTstngCpnCnt: function() {
    //     // 배명훈, 2021-11-29
    //     var examCd = this.diagnosisInfo.examCd;
    //     // alert(examCd);
    //     if(examCd == 'KEDI') {
    //         return this.dgnstTstngCpn.tediRmnngCnt;
    //     } else if(examCd == 'KEDS') {
    //         return this.dgnstTstngCpn.tedsRmnngCnt;
    //     } else if(examCd == 'ELT') {
    //         return this.dgnstTstngCpn.aieltRmnngCnt;
    //     }
    //     return 0;
    // },
    groupBy: function(list) { // 주문정보 카테고리별로 그룹핑.
        var result = [];
        var catagory = {};
        var oldCatCd= "";
        var oldCatCdNm= "";
        var orderInfo = [];
        list.forEach((item) => {
            if (oldCatCd == "") {
                oldCatCd = item.catCd;
                oldCatCdNm = item.catCdNm;
                orderInfo.push(item);
            }else{
                if (oldCatCd == item.catCd) {
                    orderInfo.push(item);
                }else if (oldCatCd != item.catCd) {
                    catagory = {catCd:oldCatCd, catCdNm:oldCatCdNm, viewYn: 'N', orderInfo:orderInfo};
                    result.push(catagory);

                    orderInfo = [];

                    oldCatCd = item.catCd;
                    oldCatCdNm = item.catCdNm;
                    orderInfo.push(item);
                }
            }
        });

        if (orderInfo.length > 0) {
            catagory = {catCd:oldCatCd, catCdNm:oldCatCdNm, viewYn: 'N', orderInfo:orderInfo};
            result.push(catagory);
        }

        return result;
    },
    updateCustInfo: function(changeInfo){ // 가망고객일 때 고객정보 수정 (소스통)
            var that = this;

            // 자녀정보 초기화
            _.each(_.range(1, 6), h => {
                this.custInfo.myCstmr['chlnnam' + h] = '';
                this.custInfo.myCstmr['chlngndr' + h] = '';
                this.custInfo.myCstmr['chlnbdt' + h] = '';
            });

            // 자녀정보 셋팅.
            for(var h=0; h < this.custInfo.custFamilyList.length; h++){
                var childInfo = this.custInfo.custFamilyList[h];
                if(h == 0){
                    this.custInfo.myCstmr.chlnnam1 = childInfo.chlnNm;
                    this.custInfo.myCstmr.chlngndr1 = childInfo.kwgend;
                    this.custInfo.myCstmr.chlnbdt1 = childInfo.chlnBrdt;
                } else if(h == 1){
                    this.custInfo.myCstmr.chlnnam2 = childInfo.chlnNm;
                    this.custInfo.myCstmr.chlngndr2 = childInfo.kwgend;
                    this.custInfo.myCstmr.chlnbdt2 = childInfo.chlnBrdt;
                } else if(h == 2){
                    this.custInfo.myCstmr.chlnnam3 = childInfo.chlnNm;
                    this.custInfo.myCstmr.chlngndr3 = childInfo.kwgend;
                    this.custInfo.myCstmr.chlnbdt3 = childInfo.chlnBrdt;
                } else if(h == 3){
                    this.custInfo.myCstmr.chlnnam4 = childInfo.chlnNm;
                    this.custInfo.myCstmr.chlngndr4 = childInfo.kwgend;
                    this.custInfo.myCstmr.chlnbdt4 = childInfo.chlnBrdt;
                } else if(h == 4){
                    this.custInfo.myCstmr.chlnnam5 = childInfo.chlnNm;
                    this.custInfo.myCstmr.chlngndr5 = childInfo.kwgend;
                    this.custInfo.myCstmr.chlnbdt5 = childInfo.chlnBrdt;
                }
            }

            // 관심및 무진정보 셋팅.
            if(this.custInfo.custInterestInfoList.length > 0){
                this.custInfo.tempCustInterestInfoList = this.custInfo.custInterestInfoList.slice();

                for(var k=this.custInfo.tempCustInterestInfoList.length - 1; k > -1; k--){
                    if(this.custInfo.tempCustInterestInfoList[k].custvalu == "N"){
                        this.custInfo.tempCustInterestInfoList.splice(k,1);
                    }
                }
            }

            var params = this.params();

            //console.log("MyCstmrView.vue regMyCstmr params", params);

            if(null != changeInfo){ // 자녀 추가나 무진정보 변경의 경우, 해당 정보를 추가로 담아서 넘긴다.
            //console.log("MyCstmrView.vue regMyCstmr changeInfo",changeInfo);
                for (var att1 in changeInfo) {
                    params[att1] = changeInfo[att1];
                }
            }

            this.$api.myCstmr.saveMyCstmr(params)
                .then(function(res) {
                    console.log("MyCstmrView.vue updateCustInfo res", res);

                    if(null != changeInfo){
                        if (changeInfo.Memo.indexOf('삭제') > -1) {
                            // 자녀 삭제 시 재 조회
                            if (that.custInfo.custFamilyList.length === 0) {
                                // 0건이면 학습 정보, 북케어 정보, 홈클래스 정보 초기화
                                that.learnDataList = [];
                                that.bookCareList = [];
                                that.homeclassList = [];
                            } else {
                                // 1건 이상이면 해당 건만 재조회
                                that.childChange(that.custInfo.custFamilyList.length - 1);
                            }
                        } else {
                           // 자녀 추가나 무진정보 변경의 경우, 메모를 다시 조회한다.
                           that.setCustMemoinit(); //초기화.
                           that.getCustMemoList();
                        }
                    }
                })
                .catch(function(error) {
                    alert(error.rtMsg);
                    location.reload();
                });
    },
    selectSearchApi: function(data){ // 진단서비스 조회
        this.diagnosisInfo.examCd = data;
        var parameters = {
            examCd: data,
            akdcde: this.searchUserid,
            tel1: this.custInfo.myCstmr.tel1,
            tel2: this.custInfo.myCstmr.tel2,
            tel3: this.custInfo.myCstmr.tel3
        };
        this.$api.eduApi
        .getMyCstmrCpon(parameters)
        .then((list) => {
          this.orgDiagnosisList = list.diagnosisList;
          this.diagnosisList = list.diagnosisList;
          console.log("this.diagnosisList==>"+JSON.stringify(this.diagnosisList));
          console.log("this.diagnosisList==>"+JSON.stringify(this.diagnosisList.examCd));
          this.examSearch = true;
          if(this.$refs.diagnosisSwiper != undefined) {
              // https://swiperjs.com/swiper-api (참조)
              this.$refs.diagnosisSwiper.$swiper.slideTo(0, 0);
          }
        })
        .catch(function (error) {
          alert(error.rtMsg);
        });
    },
    selectSearch: function(data){ // 진단서비스 조회
        //console.log(data);
        this.diagnosisInfo.examCd = data;
        var that = this;

        var parameters = {
            examCd: data,
            searchUserid: this.searchUserid,
            tel1: this.custInfo.myCstmr.tel1,
            tel2: this.custInfo.myCstmr.tel2,
            tel3: this.custInfo.myCstmr.tel3
        };
        //console.log("MyCstmrView.vue selectSearch parameters:",parameters);

        this.$api.myCstmr.gelectMyCstmrDiagnosisList(parameters)
        .then(function(res) {
          //console.log("MyCstmrView.vue selectSearch res.diagnosisList:",res.diagnosisList);
          that.orgDiagnosisList = res.diagnosisList;
          that.diagnosisList = res.diagnosisList;
          that.examSearch = true;
          if(that.$refs.diagnosisSwiper != undefined) {
              // https://swiperjs.com/swiper-api (참조)
              that.$refs.diagnosisSwiper.$swiper.slideTo(0, 0);
          }


        //   if(that.orgDiagnosisList.length > 2){
        //     that.diagnosisList = that.orgDiagnosisList.slice(0,2);
        //   }else{
        //     that.diagnosisList = that.orgDiagnosisList;
        //   }

          // 2021-11-29, 배명훈
        //  that.diagnosisInfo.examCd = res.examCd;
        //   alert(that.diagnosisList.length);
        })
        .catch(function(error) {
          alert(error.rtMsg);
        });
    },
    toggleCustOrderAllView: function(custOrderInfo){ // 주문정보 카테고리별 펼치기/닫기
        if(custOrderInfo.viewYn == "Y"){
            custOrderInfo.viewYn = "N";
        }else{
            custOrderInfo.viewYn = "Y";
        }
    },
    viewAllDiagnosis: function(){ // 진단검사결과 전체보기
        this.diagnosisList = this.orgDiagnosisList;
    },
    addChildren: function(){ // 자녀추가
        if(this.custInfo.custFamilyList.length == 5){
            alert("자녀는 5명까지 등록할 수 있습니다.");
            return false;
        }else{
            this.$utils.nativeIf.outbound.newPage('/myCstmr/myCstmrView/addChildren');
        }
    },
    modifyChildren: function(){ // 자녀수정
        var parent = {
            name: 'modify-children-pop-param',
            data: {
                child: {
                    sqno: this.childSqno,
                    chlnnam: this.childName || '',
                    chlnbdt: this.childBirth || '',
                    chlngndr: this.childSex || ''
                }
            }
        };
        this.$store.commit("SET_UI_PARENT", parent);

        this.$utils.nativeIf.outbound.newPage('/myCstmr/myCstmrView/modifyChildren');
    },
    deleteChildren: function(){ // 자녀삭제
        if(!confirm("해당 자녀를 삭제할까요?")){
            return;
        }
        alert('고객정보 수정 시 약 1분 정도의 시간이 소요됩니다.\n처리에 문제가 있는 경우 잠시 후에 다시 이용해 주세요.');

        // 자녀 정보 삭제
        const newList = _.filter(this.custInfo.custFamilyList, v => {
            return v.sqno !== this.childSqno;
        });
        this.custInfo.custFamilyList = newList;

        const changeInfo = {
            custDiv: this.custDiv,
            kwkkey: this.kwkkey,
            addChild: "Y",
            memoDiv: "0",
            Memo: "자녀가 삭제되었습니다."
        };

        this.updateCustInfo(changeInfo);
    },
    childSelect: function(){ // 자녀목록 레이어 보이기
        this.child = true;
    },
    childChange: function(idx){ // 자녀 선택했을 때
        var that = this;

        this.childName      = this.custInfo.custFamilyList[idx].chlnNm;
        this.childSex       = this.custInfo.custFamilyList[idx].kwgend;
        this.childAge       = this.custInfo.custFamilyList[idx].age;
        this.childBirth     = this.custInfo.custFamilyList[idx].chlnBrdt;
        this.childSqno     = this.custInfo.custFamilyList[idx].sqno;
        this.child = false;

        this.studyCurnt = 0;
        this.studyTotal = 0;
        this.learnDataList = [];

        var chlnKwkey = this.custInfo.custFamilyList[idx].chlnKwkey;
        //console.log("MyCstmrView.vue childChange chlnKwkey:",chlnKwkey);

        // test data
        // if('040207322' == chlnKwkey){
        //     chlnKwkey = "015040809"; // test data
        // }

        var parameters = {
            kwkkey: chlnKwkey,
            chlnKwkey: chlnKwkey,
            searchUserid: this.searchUserid,
        };

          //console.log("MyCstmrView.vue childChange parameters:",parameters);

        // 북케어 정보 조회.
        this.$api.myCstmr.getBookCareList(parameters)
        .then(function(res) {
          console.log("MyCstmrView.vue childChange res.bookCareList:",res.bookCareList);
          that.bookCareList = res.bookCareList;
        })
        .catch(function(error) {
          alert(error.rtMsg);
        });

        // 홈클래스 정보 조회.
        this.$api.myCstmr.getHomeclassList(parameters)
        .then(function(res) {
          console.log("MyCstmrView.vue childChange res.getHomeclassList:",res.homeclassList);
          that.homeclassList = res.homeclassList;
        })
        .catch(function(error) {
          alert(error.rtMsg);
        });

        // 1. 학생이 학습중인 상품리스트를 먼저 조회
        this.$api.myCstmr.selectLeanPrdList(parameters)
        .then(function(res) {
          console.log("MyCstmrView.vue childChange res.leanPrdList:",res.leanPrdList);
          var leanPrdList = res.leanPrdList;

        // 2. 조회된 리스트 건별로 학습정보 API를 호출
          for(var i=0; i < leanPrdList.length; i++){

            parameters = {
                kwKey: leanPrdList[i].chlnKwkey,
                chlnKwkey: leanPrdList[i].chlnKwkey,
                id: leanPrdList[i].apiId,
                prdtnm: leanPrdList[i].prdtnm,
            };
            that.getLrnngInfrm(parameters);

            // 창의융합영재 스쿨이면 독서마라톤도 호출한다.
            if("WP_IF_050009" == leanPrdList[i].apiId){

                parameters = {
                    kwKey: leanPrdList[i].chlnKwkey,
                    chlnKwkey: leanPrdList[i].chlnKwkey,
                    id: "WP_IF_050010",
                    prdtnm: "독서마라톤",
                };
                that.getLrnngInfrm(parameters);
            }
          }
        })
        .catch(function(error) {
          alert(error.rtMsg);
        });
    },
    getLrnngInfrm: function(parameters){ // 학습정보 인터페이스 조회
        var that = this;
          console.log("MyCstmrView.vue getLrnngInfrm parameters:",parameters);

        this.$api.myCstmr.getLrnngInfrm(parameters)
        .then(function(res) {
          console.log("MyCstmrView.vue getLrnngInfrm res:",res);
          that.learnDataList = that.learnDataList.concat(res);
          if(that.learnDataList && that.learnDataList.length > 0){
            that.studyCurnt = 1;
            that.studyTotal = that.learnDataList.length;
          }
        })
        .catch(function() {
          //alert(error.rtMsg);
        });
    },
    hideListView: function(){ // 자녀 목록 레이어 닫기
        this.child = false;
    },
    addInfo(){ // 가망고객 추가정보 저장.

        // if (this.$utils.stringUtil.isNull(this.custInfo.myCstmr.kwgend) && this.$utils.stringUtil.isNull(this.kwgendTemp)) {
        //     alert("성별을 체크해주세요.");
        //     this.$refs.kwgendTemp.focus();
        //     return false;
        // }else if(this.$utils.stringUtil.isNull(this.custInfo.myCstmr.kwbrdt)) {
        //     if(this.$utils.stringUtil.isNull(this.kwbrdtTemp)) {
        //         alert("생일을 입력해주세요.");
        //         this.$refs.kwbrdtTemp.focus();
        //         return false;
        //     }else if(!this.$utils.calendar.isBirthday(this.kwbrdtTemp)) {
        //         alert("생일을 정확하게 입력해주세요.");
        //         this.$refs.kwbrdtTemp.focus();
        //         return false;
        //     }
        // }else if(this.$utils.stringUtil.isNull(this.custInfo.myCstmr.kwsad1) && this.$utils.stringUtil.isNull(this.kwsad1Temp)) {
        //     alert("주소를 입력해주세요.");
        //     this.$refs.kwsad1Temp.focus();
        //     return false;
        // }else if(this.$utils.stringUtil.isNull(this.custInfo.myCstmr.kwsad2) && this.$utils.stringUtil.isNull(this.kwsad2Temp)) {
        //     alert("상세주소를 입력해주세요.");
        //     this.$refs.kwsad2Temp.focus();
        //     return false;
        // }

        if(!this.$utils.stringUtil.isNull(this.kwbrdtTemp) && !this.$utils.calendar.isBirthday(this.kwbrdtTemp)) { // 생일을 입력했으나, 생일형식이 아닐 때
            alert("생일을 정확하게 입력해주세요.");
            this.$refs.kwbrdtTemp.focus();
            return false;
        }

        if(!this.$utils.stringUtil.isNull(this.kwsad2Temp) && this.$utils.stringUtil.isNull(this.kwsad1Temp)) { // 상세주소 입력하고, 주소 선택 안했을 때
            alert("주소를 입력해주세요.");
            this.$refs.kwsad1Temp.focus();
            return false;
        }
        if(!this.$utils.stringUtil.isNull(this.kwsad1Temp) && this.$utils.stringUtil.isNull(this.kwsad2Temp)) { // 주소 선택하고, 상세주소 입력 안했을 때
            alert("상세주소를 입력해주세요.");
            this.$refs.kwsad1Temp.focus();
            return false;
        }

        if (this.$utils.stringUtil.isNull(this.kwgendTemp) && this.$utils.stringUtil.isNull(this.kwbrdtTemp) && this.$utils.stringUtil.isNull(this.kwsad1Temp)) {
            alert("입력된 추가정보가 없습니다.");
            this.cusIpt = false;
            return false;
        }

        // 입력한 추가정보를 담는다.
        if(!this.$utils.stringUtil.isNull(this.kwgendTemp)){
            this.custInfo.myCstmr.kwgend = this.kwgendTemp;
        }
        if(!this.$utils.stringUtil.isNull(this.kwbrdtTemp)){
            this.custInfo.myCstmr.kwbrdt = this.kwbrdtTemp;
        }
        if(!this.$utils.stringUtil.isNull(this.kwszipTemp)){
            this.custInfo.myCstmr.kwszip = this.kwszipTemp;
        }
        if(!this.$utils.stringUtil.isNull(this.kwsad1Temp)){
            this.custInfo.myCstmr.kwsad1 = this.kwsad1Temp;
        }
        if(!this.$utils.stringUtil.isNull(this.kwsad2Temp)){
            this.custInfo.myCstmr.kwsad2 = this.kwsad2Temp;
        }

        this.updateCustInfo();
        this.cusType = false;
    },
    memoView: function(item){ // 메모의 내용이 길 때, 내용 다 보기/ 2줄 보기 토글
        this.$set(item, 'isMemoView', !item.isMemoView)
    },
    goMyScheduleReg: function(){ // 일정등록 화면으로 보내기
        if(!confirm("일정등록 페이지로 이동하시겠습니까?")){
            return;
        }
        // 고객목록으로 보낼 파라메터
        var child = {
            name: "go-myschedule-reg",
            data: {
                custNm : this.custInfo.myCstmr.custNm,
                custDivCd : this.custInfo.myCstmr.custDiv,
                kwkkey : this.custInfo.myCstmr.kwkkey
            }
        };
        this.$utils.nativeIf.outbound.sendChildData(child);
    },
    goKssCstmDtl: function(){   // kss 잠재고객 상세 페이지로 이동
        var that = this;
        this.$api.myCstmr.getToken()
        .then(function(res) {
            var ssoUrl = 'http://ksos.kyowon.co.kr?';
            ssoUrl += 'userId='+ that.custInfo.myCstmrEnc.userIdEnc+'&token=' + res.token;
            ssoUrl += '&path=' + encodeURIComponent('/pioneer/pttCstmListDt?custSrno='+ that.custInfo.myCstmr.kwkkey);

            that.$utils.nativeIf.outbound.outlink(ssoUrl);
        })
        .catch(function() {
          //alert(error.rtMsg);
        });
    },
    isDgnstTstngShareable: function(index) {
        var rsltUrl= this.diagnosisList[index].rsltUrl;
        if(rsltUrl == undefined
            || rsltUrl == '') {
            return true;
        }
        return false;
    },
    viewResult: function(index){ // 진단서비스 결과공유하기
        console.log("MyCstmrView.vue viewResult rsltUrl", this.diagnosisList[index].rsltUrl);

        this.$utils.nativeIf.outbound.outlink(this.diagnosisList[index].rsltUrl);
    },
    sendKakaoTalk: function(index){ // 진단서비스 공유하기, 알림톡
        //console.log(this.diagnosisList[index]);
        // console.log("this.custInfo.myCstmr.encCustNm ",this.custInfo.myCstmr.encCustNm);
        // console.log("this.custInfo.myCstmr.encCustTel ",this.custInfo.myCstmr.encCustTel);
        if(!confirm("발송하시겠습니까?")){
            return;
        }

        var params = {
            examCd:this.diagnosisList[index].examCd,
            rsltUrl:this.diagnosisList[index].rsltUrl,
            custNm:this.diagnosisList[index].custNm,
            encCustTel:this.custInfo.myCstmr.encCustTel
        };

        this.$api.myCstmr.shareResult(params)
            .then(function() {
                alert("발송하였습니다.");
            })
            .catch(function(error) {
                alert(error.rtMsg);
            });
    },
    call: function(num){ // 전화걸기 창 띄우기
        location.href = "tel:"+num;

        // 이력저장
        this.saveMyCustMemo("고객님과 전화를 시도하였습니다.");
    },
    sms: function(myCstmr){ // 문자 발송 창 띄우기
        var smsUserList = [];
        var smsUser = {};

        smsUser = {encCustNm:myCstmr.encCustNm, encCustTel:myCstmr.encCustTel};
        smsUserList.push(smsUser);

        //console.log("MyCstmrView.vue sms smsUserList:",smsUserList);
        var parent = {
            name: 'sms-user-list',
            data: {smsUserList:smsUserList}
        };
        this.$store.commit("SET_UI_PARENT", parent);

        this.$utils.nativeIf.outbound.newPage('/myCstmr/myCstmrList/smsSend');

        // 이력저장
        this.saveMyCustMemo("고객님께 문자발송을 시도하였습니다.");
    },
    updateBkmrYn: function (myCstmr){ // 북마크 등록/삭제 처리
        console.log("MyCstmrView.vue updateBkmrYn myCstmr.kwkkey:",myCstmr.kwkkey);
        console.log("MyCstmrView.vue updateBkmrYn myCstmr.custDiv:",myCstmr.custDiv);

        var that = this;
        var params = {kwkkey:myCstmr.kwkkey,custDiv:myCstmr.custDiv};
        console.log("MyCstmrView.vue updateBkmrYn params", params);

      if("Y" == myCstmr.bookmarkYn){
        this.$api.myCstmr.deleteCustBkmr(params)
            .then(function() {
                that.custInfo.myCstmr.bookmarkYn = "N";
            })
            .catch(function(error) {
                alert(error.rtMsg);
            });
      }
      else{
        this.$api.myCstmr.saveMyCustBkmr(params)
            .then(function() {
                that.custInfo.myCstmr.bookmarkYn = "Y";
                alert(myCstmr.custNm + " 고객님을 즐겨찾기로 등록했습니다.");
            })
            .catch(function(error) {
                alert(error.rtMsg);
            });
      }
    },
    updateRecruitYn: function (myCstmr){ // 리크루트 관심있음/없음 처리
        // console.log("MyCstmrView.vue updateRecruitYn myCstmr.kwkkey:",myCstmr.kwkkey);
        // console.log("MyCstmrView.vue updateRecruitYn myCstmr.custDiv:",myCstmr.custDiv);

        var that = this;
        var params = {kwkkey:myCstmr.kwkkey,custDiv:myCstmr.custDiv};
        console.log("MyCstmrView.vue updateRecruitYn params", params);

      if("Y" == myCstmr.rcrtYn){
        this.$api.myCstmr.saveMyCustRecruit(params)
            .then(function() {
                alert("리크루팅 관심대상으로 등록되었습니다.");

                // 메모 재조회
                that.setCustMemoinit(); //초기화.
                that.getCustMemoList();
            })
            .catch(function(error) {
                alert(error.rtMsg);
            });
      }
      else{
        this.$api.myCstmr.deleteCustRecruit(params)
            .then(function() {
                alert("리크루팅 관심대상에서 제외되었습니다.");

                // 메모 재조회
                that.setCustMemoinit(); //초기화.
                that.getCustMemoList();
            })
            .catch(function(error) {
                alert(error.rtMsg);
            });
      }
    },
    getFormattedDate(dd,Type){ // 날짜(dd)를 구분자(Type)로 구별해서 보여준다.
        if(dd){
            return dd.substr(0,4) + Type + dd.substr(4,2) + Type + dd.substr(6,2);
        }else{
            return '';
        }
    },
    getFormattedMonth(dd,Type){ // 날짜(dd)를 구분자(Type)로 구별해서 연월로 보여준다.
        if(dd){
            return dd.substr(0,4) + Type + dd.substr(4,2);
        }
    },
    goCsmmView(bookCare){ // 북케어 방문확인을 위한 외부 페이지 열기
        // console.log("MyCstmrView.vue goCsmmView bookCare.rpyery", bookCare.rpyery);
        // console.log("MyCstmrView.vue goCsmmView bookCare.rpseqi", bookCare.rpseqi);
        // console.log("MyCstmrView.vue goCsmmView bookCare.rpseri", bookCare.rpseri);

        var that = this;

        this.$api.myCstmr.getToken()
        .then(function(res) {
            //console.log("MyCstmrView.vue goCsmmView getToken res:",res.token);

            var ssoUrl = 'http://ksos.kyowon.co.kr?';
            ssoUrl += 'userId='+ that.custInfo.myCstmrEnc.userIdEnc+'&token=' + res.token;
            ssoUrl += '&path=' + encodeURIComponent('/bookcare/csmmView?rpyery=' + bookCare.rpyery + '&rpseqi=' + bookCare.rpseqi + '&rpseri=' + bookCare.rpseri);
            //ssoUrl += "&path=/bookcare/csmmView?rpyery=2019&rpseqi=761073&rpseri=8"; // 테스트용 데이터.

            //console.log("MyCstmrView.vue goCsmmView ssoUrl", ssoUrl);

            that.$utils.nativeIf.outbound.outlink(ssoUrl);
        })
        .catch(function() {
          //alert(error.rtMsg);
        });

    },
    popInterestInfo: function (){ // 관심 및 무진정보 팝업
        console.log("MyCstmrView.vue popInterestInfo kwkkey",this.kwkkey);
        var parent = {
            name: 'interestInfo-pop-param',
            data: {
                    myCstmr:this.custInfo.myCstmr,
                    custDiv:this.custDiv,
                    custInterestInfoList: this.custInfo.custInterestInfoList
            }

        };
        this.$store.commit("SET_UI_PARENT", parent);

        this.$utils.nativeIf.outbound.newPage('/myCstmr/myCstmrView/interestInfo');
    },
    goEduPlan: function (){ // 에듀플랜맵으로 이동
        var param = {
            eduplan:{
                kwkkey: this.custInfo.myCstmr.kwkkey,
                custDiv: this.custInfo.myCstmr.custDiv,
                custNm: this.custInfo.myCstmr.custNm,
                targetId: this.searchUserid
            }
        }
        // this.$router.push({ name: 'plan-product', params: param });

        var parent = this.$store.getters.parent;
        Object.assign(parent.data, param)

        this.$store.commit("SET_UI_PARENT", parent);
        this.$utils.nativeIf.outbound.newPage('/eduplanmap?from=cust');
        // var param = {
        //     kwkkey: this.custInfo.myCstmr.kwkkey,
        //     custDiv: this.custInfo.myCstmr.custDiv,
        //     custNm: this.custInfo.myCstmr.custNm,
        //     targetId: this.searchUserid
        // }
        // console.log("goEduPlan param:",param);
        // this.$router.push({ name: 'plan-product', params: param });
    },
    popFamily: function (){ // 가구화 정보 팝업
        //console.log("MyCstmrView.vue popFamily kwkkey",this.kwkkey);
        var parent = {
            name: 'family-pop-param',
            data: {kwkkey:this.kwkkey,custDiv:this.custDiv}
        };
        this.$store.commit("SET_UI_PARENT", parent);

        this.$utils.nativeIf.outbound.newPage('/myCstmr/myCstmrView/familyInfo');
    },
    popCounsel: function (){ // 상담 일지 팝업
        //console.log("MyCstmrView.vue popFamily kwkkey",this.kwkkey);
        var parent = {
            name: 'popCounsel-pop-param',
            data: { kwkkey:this.kwkkey,
                    custDiv:this.custDiv,
                    custNm:this.custInfo.myCstmr.custNm}
        };
        this.$store.commit("SET_UI_PARENT", parent);

        this.$utils.nativeIf.outbound.newPage('/myCstmr/myCstmrView/CounselLog');
    },
    popRecruitInfo: function (){ // 기존 리크루팅 정보 팝업
        var parent = {
            name: 'recruit-pop-param',
            data: {searchCustNm:this.custInfo.myCstmr.custNm,tel1:this.custInfo.myCstmr.tel1,tel2:this.custInfo.myCstmr.tel2,tel3:this.custInfo.myCstmr.tel3}
        };
        console.log("MyCstmrView.vue popRecruitInfo parent",parent);
        this.$store.commit("SET_UI_PARENT", parent);

        this.$utils.nativeIf.outbound.newPage('/myCstmr/myCstmrView/recruitInfo');
    },
    popSendUrlPage: function (){ // URL 발송 페이지 팝업
        var that = this;

        this.$api.myCstmr.getToken()
        .then(function(res) {
            //console.log("MyCstmrView.vue popSendUrlPage getToken res:",res.token);

            var url = '/partner/addEpList?fromDt=&toDt=&searchKey=&srchTp=';

            var ssoUrl = 'http://ksos.kyowon.co.kr?';
            ssoUrl += 'userId='+ that.custInfo.myCstmrEnc.userIdEnc+'&token=' + res.token;

            ssoUrl += '&path=' + encodeURIComponent(url);

            //console.log("MyCstmrView.vue popSendUrlPage ssoUrl", ssoUrl);

            that.$utils.nativeIf.outbound.outlink(ssoUrl);
        })
        .catch(function() {
          //alert(error.rtMsg);
        });
    },
    popSendPartnerPage: function (){ // 외국인 파트너 등록 페이지 팝업
        var that = this;

        this.$api.myCstmr.getToken()
        .then(function(res) {
            //console.log("MyCstmrView.vue popSendPartnerPage getToken res:",res.token);

            var url = '/partner/addEpFrgn';

            var ssoUrl = 'http://ksos.kyowon.co.kr?';
            ssoUrl += 'userId='+ that.custInfo.myCstmrEnc.userIdEnc+'&token=' + res.token;
            ssoUrl += '&path=' + encodeURIComponent(url);

            //console.log("MyCstmrView.vue popSendPartnerPage ssoUrl", ssoUrl);

            that.$utils.nativeIf.outbound.outlink(ssoUrl);
        })
        .catch(function() {
          //alert(error.rtMsg);
        });
    },
    popBuyInfo: function (){ // 구매이력 정보 팝업
        var parent = {
            name: 'buy-pop-param',
            data: {
                searchUserid:this.searchUserid
                ,tel1:this.custInfo.myCstmr.tel1
                ,tel2:this.custInfo.myCstmr.tel2
                ,tel3:this.custInfo.myCstmr.tel3
            }
        };
        console.log("MyCstmrView.vue popBuyInfo parent",parent);
        this.$store.commit("SET_UI_PARENT", parent);

        this.$utils.nativeIf.outbound.newPage('/myCstmr/myCstmrView/buyInfo');
    },
    openMemoPop: function (){ // 메모 등록 팝업
        // console.log("MyCstmrView.vue openMemoPop kwkkey",this.kwkkey);
        // console.log("MyCstmrView.vue openMemoPop custDiv",this.custDiv);
        // console.log("MyCstmrView.vue openMemoPop memoDiv",this.memoDiv);
        var parent = {
            name: 'memo-pop-param',
            data: {kwkkey:this.kwkkey,custDiv:this.custDiv,memoDiv:this.memoDiv}
        };
        this.$store.commit("SET_UI_PARENT", parent);

        this.$utils.nativeIf.outbound.newPage('/myCstmr/myCstmrView/memo');
    },
    deleteCustMemo: function (index){ // 메모 삭제 처리
      if(!confirm("해당 이력을 삭제할까요?")){
        return;
      }else{
        var that = this;
        var params = {sqno:this.custMemoList[index].sqno};

        this.$api.myCstmr.deleteCustMemo(params)
            .then(function() {
                that.setCustMemoinit(); // 초기화
                that.getCustMemoList();
            })
            .catch(function(error) {
                alert(error.rtMsg);
            });
      }
    },
    setCustMemoinit: function (){ // 초기화
        this.custMemoList = [];
        this.memoTot = 0;
        this.memoOffset = 0;
        this.memoListFinal = false;
    },
    getCustMemoList: function (){ // 메모 이력 조회
        var that = this;
        var params = {kwkkey:this.kwkkey,custDiv:this.custDiv,offset:this.memoOffset,size:this.memoSize};

        this.$api.myCstmr.getCustMemoList(params)
            .then(function(res) {
                console.log("MyCstmrView.vue getCustMemoList res",res);

                if(null != res){
                    var list = res.memoList;
                    that.custMemoList = that.custMemoList.concat(list);
                    that.memoTot = res.totCnt;
                    that.memoOffset += that.memoSize;
                    if(list.length < that.memoSize){
                        that.memoListFinal = true;
                    }
                }
            })
            .catch(function(error) {
                alert(error.rtMsg);
            });
    },
    saveMyCustMemo: function(memo){ // 이력저장.
        var that = this;
        var params = {kwkkey:this.kwkkey,custDiv:this.custDiv,memoDiv:"0",memo:memo};
        console.log("MyCstmrView.vue api.myCstmr.saveMyCustMemo params:",params);

        this.$api.myCstmr.saveMyCustMemo(params)
            .then(function(res) {
                console.log("MyCstmrView.vue saveMyCustMemo res", res);

                that.setCustMemoinit(); //초기화.
                that.getCustMemoList();
            })
    },
    getNameGen: function (){ // 고객 이름과 성별 리턴
        var name = "";
        var gen = "";
        if(this.custInfo.myCstmr.custNm){
            name = this.custInfo.myCstmr.custNm;
        }
        if(this.custInfo.myCstmr.kwgend){
            gen = this.custInfo.myCstmr.kwgend;
        }
        var nameGen = name;
        if(gen && (gen == 1 || gen == 2 || gen == "M" || gen == "F")){
            nameGen = name + "(" + this.checkKwgend(gen) + ")";
        }
        return nameGen;
    },
    checkKwgend: function(kwgend){ // 성별 코드를 남/여 로 변경해서 리턴
        var gen = "";
        if("1" == kwgend || "M" == kwgend){
            gen = "남";
        }else if("2" == kwgend || "F" == kwgend){
            gen = "여";
        }
        return gen;
    },
    checkText: function(e){ // 입력 길이 체크
        if(e.target.id == 'kwbrdtTemp' ){
            if(e.target.value.length > 8){
                e.target.value = e.target.value.substr(0,8);
            }else{
                this.kwbrdtTemp = e.target.value;
            }
        }
        if(e.target.id == 'kwsad2Temp' ){
            if(e.target.value.length > 30){
                e.target.value = e.target.value.substr(0,30);
            }else{
                this.kwsad2Temp = e.target.value;
            }
        }
    },
    getTelNum: function(){ // 전화번호 모두 있을 때 '-' 넣어서 표시.
        if(this.custInfo.myCstmr.tel1 != null && this.custInfo.myCstmr.tel2 != null && this.custInfo.myCstmr.tel3 != null){
            return this.custInfo.myCstmr.tel1 + '-' + this.custInfo.myCstmr.tel2 + '-' + this.custInfo.myCstmr.tel3;
        }
    },
    getMinuteFromSeconds: function(seconds){ // 초를 분으로 변경
        var min = 0;
        if(!seconds && typeof seconds != "undefined"){
            min = parseInt(seconds/60);
        }

        return min;
    },
    popView: function (index){ // 상세보기 화면으로
      //this.$router.push('/mySchedule/myScheduleView/' + this.schedule.myScheduleList[index].sqno);
      this.myScheduleListIndex = index;
      this.$utils.nativeIf.outbound.newPage('/mySchedule/myScheduleView/' + this.custInfo.myScheduleList[index].sqno);
    },
    removeKM: function (extraTotSum){ // km 문자열 제거 후 리턴.
        var km = 0;
        if(typeof extraTotSum != "undefined"){
            km = extraTotSum.replace("km",'');
        }
        return km;
    },
    openModifyMemoPop: function (index){ // 메모 수정 팝업
        var parent = {
            name: 'memo-pop-param',
            data: {sqno:this.custMemoList[index].sqno,kwkkey: this.kwkkey, custDiv: this.custDiv, memoDiv: this.memoDiv}
        };
        this.$store.commit("SET_UI_PARENT", parent);

        this.$utils.nativeIf.outbound.newPage('/myCstmr/myCstmrView/modifyMemo');
    },
    goOrgnzDetail : function(userInfo){
        var param = "&gubun="+userInfo.orgnzPstn;
        param += "&akdnam="+userInfo.userName;
        this.$utils.nativeIf.outbound.newPage("/orgStatus/orgStatusView?targetId="+userInfo.userId+param)
    },
    getUserInfoByUserid() { // 해당 직원의 정보 조회
        var that = this;
        var params = {searchUserid : this.searchUserid};
        //console.log("UserScheduleList.vue getUserScheduleList that.params", that.params);
        this.$api.myschedule.getUserInfoByUserid(params)
        .then(function(res) {
            //console.log( "UserScheduleList.vue <api.myschedule.getUserInfoByUserid.response>",  res.userInfo );
            that.userInfo = res.userInfo; // 담당자 정보.
        })
        .catch(function(error) {
            alert(error.rtMsg);
        });
    },
  },
  filters:{
    checkKwgend: function(kwgend){ // 성별 코드를 남/여 로 변경해서 리턴
        var gen = "";
        if("1" == kwgend|| "M" == kwgend){
            gen = "남";
        }else if("2" == kwgend || "F" == kwgend){
            gen = "여";
        }
        return gen;
    },
    comma(val){ // 금액일 때, 콤마 추가해서 리턴
        var commaVal = "0";
        if(val && typeof val  != 'undefined'){
            commaVal = String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
        return commaVal;
    },
  },
  mounted: function() { //  인스턴스가 마운트 된 직후
    if(typeof this.$route.query.userId != 'undefined'
        && typeof this.$route.query.kwkkey != 'undefined'
        && typeof this.$route.query.custDiv != 'undefined' ) {

        this.searchUserid = this.$route.query.userId;
        this.kwkkey = this.$route.query.kwkkey;
        this.custDiv = this.$route.query.custDiv;

        // 고객정보 조회
        this.getMyCstmr();
        // ep정보 조회
        this.getUserInfoByUserid();
    }
  }
};
</script>

<style>
    .swiper-pagination-bullets .swiper-pagination-bullet {margin: 0 2px !important;}
    .swiper-pagination-bullet {width: 6px !important;height: 6px !important;border-radius: 3px !important;}
    .swiper-pagination-bullet-active {width: 10px !important;background-color: rgb(52,41,109) !important;}
    .swiperOption3 {left: 50%;bottom: 12px;transform: translateX(-50%) !important;}
</style>
